import { AuditUserType } from "types/business/AuditUserType";
import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = AuditUserType[];

export const useDefaultObservableAuditUserTypeArray = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectAuditUserTypeArray extends BehaviorSubject<CurrentType> {}
